import { useMutation } from "react-query";
import { createAccount } from "../api/account/createAccount";
import { queryClient } from "./transactionsStore";
import { ACCOUNT_META_QUERY_KEY } from "./useQueryGetAccounts";

export const useMutationCreateAccount = () =>
  useMutation(ACCOUNT_META_QUERY_KEY, createAccount, {
    onSuccess: () => queryClient.invalidateQueries([...ACCOUNT_META_QUERY_KEY]),
  });
